import styled from '@emotion/styled';

export const BannerTableContainer = styled.div`
    td {
        padding-top: 18px !important;
        padding-bottom: 18px !important;
    }

    td:first-of-type p {
        max-width: 250px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap !important;
    }
`;

export const HeaderContainer = styled.div`
    padding: 25px;
`;

export const Header = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 24px;
`;
